import React from 'react';
import { loan_type_css } from '../Const';

interface Props {
  loan_css: string;
  current: number;
}

const ProcedureStep: React.FC<Props> = ({ loan_css, current }) => {
  return (
    <ul className={`procedure ${loan_css}`}>
      <li className={`procedure-step ${current === 1 && '-current'}`}>
        <span className="step">Step1</span>
        {loan_css === loan_type_css.agriculture ? '借入相談' : '事前審査申込'}
      </li>
      <li className={`procedure-step ${current === 2 && '-current'}`}>
        <span className="step">Step2</span>
        借入申込
      </li>
      <li className={`procedure-step ${current === 3 && '-current'}`}>
        <span className="step">Step3</span>
        契約申込
      </li>
      <li className={`procedure-step ${current === 4 && '-current'}`}>
        <span className="step">Step4</span>
        契約手続き
      </li>
      <li className={`procedure-step ${current === 5 && '-current'}`}>
        <span className="step">Step5</span>
        完了
      </li>
    </ul>
  );
};

export default ProcedureStep;
